var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"div1",class:{hover:_vm.isHover},on:{"mouseover":_vm.handleMouseover,"mouseout":_vm.handleMouseOut}},[_vm._v("鼠标移入改变样式，鼠标移出恢复。")])])}
var staticRenderFns = []

export { render, staticRenderFns }